module.exports = __webpack_public_path__ + "img/iphone.7613b726.png";